/**
 * Tenant-readiness hook.
 *
 * Collapses the repeated `!!currentRetailerCode && !!currentEnvironment` guard
 * used across the data hooks to gate queries until a retailer and environment
 * are selected. Compose with extra dependencies where needed, e.g.
 * `enabled: tenantReady && !!jobId`.
 *
 * @packageDocumentation
 */

import { useEnvironmentStore } from '@/stores';

/**
 * Returns whether the multi-tenant context is ready for data fetching.
 *
 * @returns { boolean } Returns true once both a retailer code and environment are selected.
 */
export const useTenantReady = (): boolean =>
  useEnvironmentStore((s) => !!s.currentRetailerCode && !!s.currentEnvironment);
